<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the layout."
            :error="(errors.name || [])[0]"
        />

        <SelectFormGroup
            v-if="!edit"
            v-model="data.layout_category"
            name="layout_category"
            label="Layout Category"
            help-text="The layout category of the layout."
            :error="(errors.layout_category || [])[0]"
            :options="layoutCategoryOptions"
        />

        <hr>

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SelectFormGroup,SubmitFormGroup, TextFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    edit: {
      required: false,
      default: false
    },

    layoutCategories: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      data: {...this.initial}
    }
  },

  computed: {
    layoutCategoryOptions() {
      return this.layoutCategories.map(layoutCategory => ({
        value: layoutCategory.id,
        label: layoutCategory.attributes.name,
      }))
    }
  }
}
</script>